import React from "react";
import { Chart } from "react-google-charts";
import Spinner from "../../../spinner/spinner";

export default function TotalSales({ data, loading, showChart }) {

    const options = {
        title: 'Total Sales (Month Wise)',
        fontSize: 15,
        hAxis: {
            title: 'Month',
            titleTextStyle: {
                color: '#333',
                bold: true,
                fontSize: 15
            },
            textStyle: {
                color: '#333'
            },
        },
        vAxis: {
            title: 'Net Total (LKR)',
            titleTextStyle: {
                color: '#333',
                bold: true,
                fontSize: 15
            },
            textStyle: {
                color: '#333'
            },
        },
        series: {
            0: { color: '#ff0000' },
            1: { color: '#0000ff' },
        },
        legend: 'right',
        chartArea: { width: "50%" },
    }

    return (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
            {loading ? (
                <Spinner />
            ) : (
                <React.Fragment>
                    {showChart ? (
                        data.length > 1 ? (
                            <Chart
                                chartType="LineChart"
                                style={{ marginTop: "20px", marginBottom: "20px", width: "100%", height: "400px" }}
                                width="100%"
                                height="400px"
                                data={data}
                                options={options}
                            />
                        ) : (
                            <h3>No Data Available</h3>
                        )
                    ) : null}
                </React.Fragment>
            )}
        </div>
    );
}